import { Clock, Ban, Info, CheckCircle } from 'lucide-react';

const policies = [
  {
    icon: Clock,
    title: 'Check-in / Check-out',
    items: [
      '24 Hours Check-in Available',
      'Check-in: 12:00 PM',
      'Check-out: 11:00 AM',
      'Early check-in subject to availability',
      'Late check-out may incur additional charges',
    ],
  },
  {
    icon: Ban,
    title: 'Property Rules',
    items: [
      'Pets are not allowed',
      'No events or parties permitted',
      'Smoking only in designated areas',
      'Valid ID required at check-in',
    ],
  },
  {
    icon: CheckCircle,
    title: 'Cancellation',
    items: [
      '10% deduction for cancellation before 24 hrs',
      'Cancellation charges apply for late cancellations',
      'Contact us for special circumstances',
      'Full refund for hotel-initiated cancellations',
    ],
  },
  {
    icon: Info,
    title: 'Important Information',
    items: [
      'Government-issued photo ID required',
      'Credit/Debit cards accepted',
      'Extra bed available on request',
      'Children up to 10 years stay free',
    ],
  },
];

export function Policies() {
  return (
    <section className="py-16 sm:py-24 bg-white">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="mb-4">Hotel Policies</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Please review our policies to ensure a smooth and pleasant stay at Hotel A.S.K Grand.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {policies.map((policy, index) => {
            const Icon = policy.icon;
            return (
              <div
                key={index}
                className="bg-gray-50 rounded-xl p-6 hover:shadow-md transition-shadow"
              >
                <div className="w-12 h-12 bg-gold-100 rounded-lg flex items-center justify-center mb-4">
                  <Icon className="w-6 h-6 text-gold-600" />
                </div>
                <h3 className="mb-4">{policy.title}</h3>
                <ul className="space-y-2">
                  {policy.items.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-gray-600 text-sm">
                      <span className="text-gold-600 mt-1">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <div className="mt-12 bg-gold-50 rounded-xl p-8">
          <div className="max-w-3xl mx-auto text-center">
            <h3 className="mb-4">Questions About Our Policies?</h3>
            <p className="text-gray-600 mb-6">
              Our team is here to help clarify any questions you may have about our policies and procedures.
            </p>
            <a
              href="tel:+917799933325"
              className="inline-block bg-gold-600 text-white px-8 py-3 rounded-lg hover:bg-gold-700 transition"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
